module.exports = __webpack_public_path__ + "img/act_icon_0.66640d8.png";